import React from 'react';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line max-len
import { type EventApplicationEntrypointContextDataFragment } from '../../../api/fragments/EventApplicationEntrypointContextData';
import { useGetEventQuery } from '../../../api/queries/getEvent';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import withPrivateAccess from '../../../utilities/withPrivateAccess';
import EventDetailsInnerPage from './EventDetailsInnerPage';

export type EventDetailsPageProps = {
    disabled?: boolean;
    endpoint?: EventApplicationEntrypointContextDataFragment;
};

const EventDetailsPage = ({ endpoint, disabled = true }: EventDetailsPageProps) => {
    const { eventSlug } = useParams<{ eventSlug: string }>();
    const { data, loading } = useGetEventQuery({
        fetchPolicy: 'network-only',
        variables: { urlSlug: eventSlug, eventModuleId: endpoint.eventApplicationModule.id },
    });

    const event = data?.event;

    if (!event && loading) {
        return <LoadingElement />;
    }

    if (!event) {
        return <NotFoundResult />;
    }

    return <EventDetailsInnerPage disabled={disabled} event={event} />;
};

export default withPrivateAccess(EventDetailsPage);
